import React from 'react';

export default function TermsOfService({ onClose }) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(63, 197, 212, 0.24)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: '90%',
          maxWidth: 460,
          background: 'linear-gradient(180deg, #4FC3D4 0%, #3AA8B8 100%)',
          borderRadius: 26,
          position: 'relative',
          padding: '40px 28px 28px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.23)',
          maxHeight: '90vh',
          overflowY: 'auto',
        }}
        onClick={e => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          style={{
            border: 'none',
            background: 'rgba(255,255,255,0.32)',
            fontSize: 22,
            position: 'absolute',
            top: 22,
            right: 24,
            cursor: 'pointer',
            width: 36,
            height: 36,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontWeight: 'bold',
            zIndex: 10,
          }}
        >
          ✕
        </button>

        <h2
          style={{
            margin: '0 0 20px 0',
            textAlign: 'center',
            color: '#fff',
            fontSize: 27,
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '1px',
            textShadow: '0 2px 6px rgba(0,0,0,0.18)',
          }}
        >
          • TERMS OF SERVICE •
        </h2>

        <div
          style={{
            background: 'rgba(255,255,255,0.96)',
            borderRadius: 14,
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            padding: '24px 17px',
            color: '#333',
            fontSize: 15,
            lineHeight: 1.75,
            marginTop: 2,
            marginBottom: 10
          }}
        >
          <div style={{ marginBottom: 8, fontSize: 14, opacity: 0.75 }}>
            Last updated: November 13, 2025
          </div>
          <p style={{ marginBottom: 15 }}>
            By accessing or using MNWalk Idle, you agree to comply with these Terms of Service. MNWalk Idle is operated by Limelight Labs. Please read these terms carefully before using the site.
          </p>

          <h3 style={{fontWeight:700, color:'#3AA8B8', fontSize:17}}>1. Acceptance of Terms</h3>
          <ul style={{marginLeft:19, marginBottom: 10}}>
            <li>You must be at least the age of majority in your jurisdiction to use this service. By using the service, you confirm that you have the legal capacity to enter into a binding agreement and that you will comply with all applicable laws and regulations.</li>
            <li>If you do not agree with any part of these terms, you should stop using the service immediately.</li>
          </ul>

          <h3 style={{fontWeight:700, color:'#3AA8B8', fontSize:17}}>2. Account Responsibilities</h3>
          <ul style={{marginLeft:19, marginBottom: 10}}>
            <li>You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</li>
            <li>You agree to notify us promptly of any unauthorized use or security breach. We are not liable for any loss or damage arising from your failure to safeguard your account information.</li>
          </ul>

          <h3 style={{fontWeight:700, color:'#3AA8B8', fontSize:17}}>3. Service Access and Availability</h3>
          <ul style={{marginLeft:19, marginBottom: 10}}>
            <li>We strive to provide reliable access to MNWalk Idle but do not guarantee uninterrupted or error-free service. Maintenance, updates, or technical issues may result in temporary downtime.</li>
            <li>We reserve the right to modify, suspend, or discontinue any part of the service at any time without prior notice.</li>
          </ul>

          <h3 style={{fontWeight:700, color:'#3AA8B8', fontSize:17}}>4. Prohibited Conduct</h3>
          <ul style={{marginLeft:19, marginBottom: 10}}>
            <li>You agree not to misuse the service or interfere with its proper functioning. Prohibited activities include reverse engineering, automated scraping, attempting to gain unauthorized access, or using the service in a way that violates applicable laws or third-party rights.</li>
            <li>We reserve the right to suspend or terminate accounts that engage in prohibited conduct.</li>
          </ul>

          <h3 style={{fontWeight:700, color:'#3AA8B8', fontSize:17}}>5. Disclaimers and Limitation of Liability</h3>
          <ul style={{marginLeft:19, marginBottom: 10}}>
            <li>MNWalk Idle is provided on an "as is" and "as available" basis. We make no warranties, express or implied, regarding the accuracy, reliability, or availability of the service.</li>
            <li>To the maximum extent permitted by law, we are not liable for any indirect, incidental, or consequential damages arising out of your use of the service.</li>
          </ul>

          <h3 style={{fontWeight:700, color:'#3AA8B8', fontSize:17}}>6. Changes to These Terms</h3>
          <ul style={{marginLeft:19, marginBottom: 10}}>
            <li>We may update these terms from time to time. When we do, we will revise the "Last updated" date at the top of this page.</li>
            <li>Your continued use of the service after changes become effective constitutes acceptance of the revised terms.</li>
          </ul>

          <div style={{ marginTop: 10 }}>
            If you have any questions about these Terms of Service, please contact us at <a href="mailto:jwjpop@gmail.com" style={{color: "#3AA8B8"}}>jwjpop@gmail.com</a>
          </div>
        </div>
      </div>
    </div>
  );
}
